// Verification tiers for abuser records — inferred from source_url / source_label.
// Official = government / court / DA / official state cruelty registry.
// Court = appellate or court opinion database (verified case docket).
// News = regular journalism (still linked to a primary court action, but not a primary document).
//
// Keeping this client-side (not a DB field) means we don't have to migrate 251 records;
// adding a new source just requires updating the regex list.

const OFFICIAL_DOMAINS = [
  // Government / .gov / state DOJ / county DA / sheriff registries
  ".gov",
  "justice.gov",
  "usao-edca",
  "adamsbroomfieldda.org",          // CO 17th Judicial DA
  "buttecounty.net",                // Butte County DA
  "pasadosafehaven.org",            // WA Bucky Award + official docket references
  "aldf.org",                       // Animal Legal Defense Fund case database
  "animallaw.info",                 // Michigan State U. animal-law case DB
  "courtnewsohio.gov",
  "cookcountysheriffil.gov",        // Cook County Animal Abuser Registry
  "safehumanechicago.org/programs/court-advocacy",
  "clarkcountynv.gov",
  "dps.alaska.gov",
  "houstondistrictattorney",
  "idausa.org",
  "animalwellnessaction.org",
];

// Labels that indicate the record came from an official registry / court filing
const OFFICIAL_LABEL_HINTS = [
  "TBI",                            // Tennessee Bureau of Investigation
  "Henrico",                        // VA Henrico registry
  "Cook County",
  "DOJ",
  "DA's Office",
  "DA — ",
  "DA —",
  "District Attorney",
  "U.S. Attorney",
  "State v.",
  "Supreme Court",
  "Court of Appeals",
  "Superior Court",
  "Alaska DPS",
  "Department of Justice",
  "Attorney General",
  "Court News Ohio",
  "Animal Abuser Registry",
];

export function verificationTier(abuser) {
  if (!abuser) return "news";
  const url = (abuser.source_url || "").toLowerCase();
  const label = (abuser.source_label || "") + " " + (abuser.case_id || "");
  if (OFFICIAL_DOMAINS.some((d) => url.includes(d.toLowerCase()))) return "official";
  if (OFFICIAL_LABEL_HINTS.some((hint) => label.toLowerCase().includes(hint.toLowerCase()))) return "official";
  return "news";
}

export function verificationMeta(tier) {
  if (tier === "official") {
    return {
      label: "Verified registry",
      short: "Verified",
      description: "Sourced from a government registry, court filing, or official prosecutor's office.",
      cls: "bg-green-500 text-white border-green-700",
    };
  }
  return {
    label: "News source",
    short: "News",
    description: "Sourced from journalism; verify against the underlying court record before taking any action.",
    cls: "bg-zinc-200 text-zinc-900 border-zinc-400",
  };
}
